import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PricingCard } from './PricingCard';
import { VPSLocationSelector } from './VPSLocationSelector';
import { Server, Shield, Cpu, Zap } from 'lucide-react';

export function VPSPlans() {
  const { t } = useTranslation();
  const [location, setLocation] = useState<'game' | 'performance'>('game');

  const vpsPlans = t(`vps.plans.de.${location}`, { returnObjects: true }) || [];
  const vpsLinks = {
    game: [
      'https://my.synthohosting.net/index.php?rp=/store/vps-gaming/vpsgaming1',
      'https://my.synthohosting.net/index.php?rp=/store/vps-gaming/vpsgaming2',
      'https://my.synthohosting.net/index.php?rp=/store/vps-gaming/vpsgaming3',
      'https://my.synthohosting.net/index.php?rp=/store/vps-gaming/vpsgaming4',
      'https://my.synthohosting.net/index.php?rp=/store/vps-gaming/vpsgaming5',
      'https://my.synthohosting.net/index.php?rp=/store/vps-gaming/vpsgaming6',
      'https://my.synthohosting.net/index.php?rp=/store/vps-gaming/vpsgaming7',
      'https://my.synthohosting.net/index.php?rp=/store/vps-gaming/vpsgaming8',
      'https://my.synthohosting.net/index.php?rp=/store/vps-gaming/vpsgaming9',
      'https://my.synthohosting.net/index.php?rp=/store/vps-gaming/vpsgaming10'
    ],
    performance: [
      'https://example.com/store/vps/de/perf/nano',
      'https://example.com/store/vps/de/perf/micro',
      'https://example.com/store/vps/de/perf/lite',
      'https://example.com/store/vps/de/perf/boost',
      'https://example.com/store/vps/de/perf/turbo',
      'https://example.com/store/vps/de/perf/power',
      'https://example.com/store/vps/de/perf/pro',
      'https://example.com/store/vps/de/perf/max',
      'https://example.com/store/vps/de/perf/ultra',
      'https://example.com/store/vps/de/perf/hyper'
    ]
  };

  return (
    <div className="py-20 bg-gray-50" id="plans">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">{t('vps.plans.title')}</h2>
          <p className="text-xl text-gray-600">{t('vps.subtitle')}</p>
        </div>

        <VPSLocationSelector selectedLocation={location} onLocationChange={setLocation} />

        {location === 'performance' ? (
          <div className="flex items-center justify-center py-20">
            <div className="w-full md:w-3/4 lg:w-2/3 text-center bg-gradient-to-r from-purple-600 to-purple-700 text-white px-8 py-12 rounded-2xl shadow-lg">
              <div className="flex items-center justify-center gap-3 mb-4">
                <Zap className="w-7 h-7" />
                <h2 className="text-2xl font-bold">{t('vps.comingSoon.title')}</h2>
              </div>
              <p className="mt-4 text-lg text-purple-100 max-w-2xl mx-auto">
                {t('vps.comingSoon.description')}
              </p>
            </div>
          </div>
        ) : (
          <div className="grid md:grid-cols-3 lg:grid-cols-5 gap-8">
            {Array.isArray(vpsPlans) &&
              vpsPlans.map((plan, index) => (
                <PricingCard
                  key={index}
                  {...plan}
                  buyLink={vpsLinks[location][index]}
                  isPopular={plan.title.includes('Turbo')}
                />
              ))}
          </div>
        )}

      </div>
    </div>
  );
}
